export default __webpack_public_path__ + "static/kayiArcher-e58093322305179dd6338c33ad117fff.png";